module.exports = __webpack_public_path__ + "img/twitterIcon.75497fc5.png";